import { colors } from 'bench-style-constants';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useClickOutside } from './useOnClickOutside';

const RightSidebar = styled.div`
  background: ${colors.white};
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.16);
  width: 450px;
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

type DismissibleSidebarProps = {
  dismissSidebar: () => void;
  preventDismiss?: (event: MouseEvent) => boolean;
};

const DismissibleRightSidebar = ({
  children,
  dismissSidebar,
  preventDismiss,
}: PropsWithChildren<DismissibleSidebarProps>) => {
  const ref = React.useRef(null);
  useClickOutside(ref, dismissSidebar, preventDismiss);

  React.useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        dismissSidebar();
      }
    };
    window.addEventListener('keydown', close);
    return () => {
      window.removeEventListener('keydown', close);
    };
  }, [dismissSidebar]);

  return (
    <RightSidebar role="dialog" ref={ref}>
      {children}
    </RightSidebar>
  );
};

export default DismissibleRightSidebar;
